<template>
  <div>
    <div class="row d-none d-lg-flex">
      <a
          v-for="group in groups"
          :key="group"
          href="#"
          :class="itemClass"
          @click.prevent="selectGroup(group)"
      >
        <h3 :class="{'text-primary': selectedGroup === group }">
          {{ group }}
        </h3>
      </a>
    </div>
    <div class="d-lg-none">
      <select class="form-control" @change="selectGroup(groupFromSelect)" v-model="groupFromSelect">
        <option value="" >Válassz modellt</option>
        <option v-for="group in groups" :key="group">{{ group }}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {Component, Prop, Watch} from 'vue-property-decorator';
  import {namespace} from 'vuex-class';

  const modelModule = namespace('model');

  @Component
  export default class ModelFilter extends Vue {
    @modelModule.Getter('getGroups') groups;
    @modelModule.Getter('getSelectedGroup') selectedGroup;
    @modelModule.Action('fetchAll') fetchAll;
    @modelModule.Action('selectGroup') selectGroup;
    @modelModule.Mutation('setMode') setMode;
    @Prop(Array) models;
    @Prop(Boolean) groupByMake;
    // Grid width of one make link. Overridable so a full-width page can pack more per row.
    @Prop({type: String, default: 'col-12 col-sm-6 col-md-4 col-lg-4'}) itemClass;

    groupFromSelect = '';

    created() {
      this.fetchAll(this.models);

      if (this.groupByMake) {
        this.setMode('make')
      }

      if (location.hash) {
        this.selectGroup(decodeURIComponent(location.hash.substr(1)));
        this.groupFromSelect = decodeURIComponent(location.hash.substr(1));
      }
    }

    @Watch('selectedGroup')
    watchSelectedGroup() {
      this.groupFromSelect = this.selectedGroup;
    }
  }

</script>
